import decode from 'jwt-decode';

import Dashboard from '../views/Dashboard/Dashboard.jsx';
import Administration from '../views/Administration/Main.jsx';
import Calendar from '../views/Calendar/Calendar.jsx';
import Contacts from '../views/Contacts/Main.jsx';
import ViewContact from '../views/Contacts/View.jsx';
import ProjectManagement from '../views/ProjectManagement/Main.jsx';
import ProjectManagementEdit from '../views/ProjectManagement/Edit.jsx';
import UsersManagement from '../views/UsersManagement/Main.jsx';
import Incubation from '../views/Incubation/Main.jsx';
import PreEvaluate from '../views/Incubation/PreEvaluate.jsx';
import UserPage from '../views/Pages/UserPage.jsx';
import NotificationPage from '../views/Pages/NotificationPage.jsx';
import EditUser from '../views/UsersManagement/Edit.jsx';
import IncubationPage from '../views/Incubation/IncubationPage/Main.jsx';
import Uncusa from '../views/Uncusa/Main.jsx';

// HOC for permissions
import Authorization from './Authorization';

const token = localStorage.getItem('id_token');
let administrationPermission = false;
let uncusaPermission = false;
let projectMgntPermission = false;
let incubationPermission = false;
let incubationPagePermission = false;
let userManagementPermission = false;
let currentUser = null;
if (token) {
  currentUser = decode(token);
  // Permissions
  administrationPermission = [
    'Asistente Técnico de Gestión',
    'Coordinador',
    'Contabilidad',
    'Administrador Sistema'
  ].includes(currentUser.roles[0]);

  uncusaPermission = [
    'UNCUSA'
  ].includes(currentUser.roles[0]);

  projectMgntPermission = [
    'Administrador Sistema',
    'Asistente Técnico de Gestión',
    'Coordinador',
    'Administrador Sistema',
  ].includes(currentUser.roles[0]);

  incubationPermission = [
    'Coordinador',
    'Asistente Técnico de Gestión',
  ].includes(currentUser.roles[0]);

  incubationPagePermission = [
    'Coordinador',
    'Asistente Técnico de Gestión',
    'Emprendedores',
  ].includes(currentUser.roles[0]);

  userManagementPermission = [
    'Coordinador',
    'Administrador Sistema',
  ].includes(currentUser.roles[0]);
}

var dashRoutes = [
    {
      path: "/dashboard",
      name: "Indicadores",
      icon: "pe-7s-graph",
      component: Dashboard,
      exact: true
    },
    {
      path: "/administration",
      name: "Administración",
      icon: "pe-7s-piggy",
      component: Authorization(Administration, administrationPermission),
      exact: true,
      hidden: !administrationPermission,
      currentUser
    },
    {
      path: "/calendar",
      name: "Calendario",
      icon: "pe-7s-date",
      component: Calendar,
      exact: true
    },
    {
      path: "/contacts",
      name: "Contactos",
      icon: "pe-7s-id",
      component: Contacts,
      exact: true,
      currentUser,
    },
    // sub routes contacts
    {
      path: "/contacts/:action",
      name: "Contactos",
      icon: "pe-7s-id",
      component: ViewContact,
      hidden: true,
      exact: true
    },
    {
      path: "/contacts/:action/:number",
      name: "Contactos",
      icon: "pe-7s-id",
      component: ViewContact,
      hidden: true,
      exact: false
    },
    {
      path: "/project-management",
      name: "Gestor de Actividades",
      icon: "pe-7s-config",
      component: Authorization(ProjectManagement, projectMgntPermission),
      exact: true,
      hidden: !projectMgntPermission
    },
    {
      path: "/project-management/edit/:number",
      name: "Gestor de Actividades",
      icon: "pe-7s-config",
      component: Authorization(ProjectManagementEdit, projectMgntPermission),
      hidden: true,
      exact: true
    },
    {
      path: "/users-management",
      name: "Usuarios y grupos",
      icon: "pe-7s-users",
      component: Authorization(UsersManagement, userManagementPermission),
      exact: true,
      hidden: !userManagementPermission,
    },
    // sub routes users-management
    {
      path: "/users-management/edit/:number",
      name: "Usuarios y grupos",
      icon: "pe-7s-users",
      component: Authorization(EditUser, userManagementPermission),
      hidden: true,
      exact: false
    },
    {
      path: "/users-management/create",
      name: "Usuarios y grupos",
      icon: "pe-7s-users",
      component: Authorization(EditUser, userManagementPermission),
      hidden: true,
      exact: true
    },
    {
      path: "/incubation",
      name: "Incubación",
      icon: "pe-7s-rocket",
      component: Authorization(Incubation, incubationPermission),
      exact: true,
      hidden: !incubationPermission,
      currentUser,
    },
    {
      path: "/incubation/pre-evaluate/:number",
      name: "Pre Evaluar Proyecto",
      icon: "pe-7s-rocket",
      component: Authorization(PreEvaluate, incubationPermission),
      hidden: true,
      exact: false
    },
    {
      path: currentUser && currentUser.roles[0] === 'Emprendedores' ? `/incubation/my-project` : "/incubation/:number/:state",
      name: currentUser && currentUser.roles[0] === 'Emprendedores' ? "Mi Proyecto" : "Incubación",
      icon: "pe-7s-rocket",
      component: Authorization(IncubationPage, incubationPagePermission),
      hidden: currentUser && currentUser.roles[0] !== 'Emprendedores' && true,
      exact: false,
      currentUser,
    },
    {
      path: "/pages/user-page",
      name: "Perfil",
      icon: "pe-7s-rocket",
      component: UserPage,
      hidden: true
    },
    {
      path: "/pages/notifications",
      name: "Notificaciones",
      icon: "pe-7s-rocket",
      component: NotificationPage,
      hidden: true
    },
    {
      path: "/uncusa",
      name: "UNCUSA",
      icon: "pe-7s-link",
      component: Authorization(Uncusa, uncusaPermission),
      exact: true,
      hidden: !uncusaPermission,
    },
    {
      redirect: true,
      path: "/",
      pathTo: "/dashboard",
      name: "Dashboard",
    }
];

export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dash.jsx